/**
 * The words that must not drift, in one file.
 *
 * WORDING IS OURS TO DECIDE (decision-log row 99: "LAYOUT, WORDING, COLUMNS AND NAVIGATION ARE
 * OURS"), so most of the cabinet's copy lives beside the component that says it. Three strings do
 * not, and they are here:
 *
 *   1. THE OWNER'S OWN LINE. "No password to remember" is the line the owner paired with the two
 *      provider buttons in his sign-in drawing. The prototype contains no sign-in pixel at all —
 *      re-derived at HEAD over all 200 files: "Sign in with Apple", "Sign in with Google", "No
 *      password to remember", "sign in", "signIn" and "/enter" each occur ZERO times — so the
 *      drawing is intent delivered directly, exactly as decision-log row 117 anticipated. Keeping
 *      the line verbatim is honouring intent, not copying a spec.
 *
 *   2. THE ONE HAND-OFF REFUSAL. Unknown, expired and already-used arrive as ONE 401 with
 *      `HANDOFF_CODE_INVALID` and "nothing in the body distinguishes them"
 *      (docs/design/07-api/authors-api.yaml). One constant, so nobody can write a second
 *      message for a case they cannot actually detect. Milestone A1's acceptance script requires
 *      all three refusals to be indistinguishable (docs/design/12-build-plan.md).
 *
 *   3. THE OUTAGE LINE. A 503 must read as "we cannot check right now", never as "you are signed
 *      out" — that difference is the entire reason adr/0010-firebase-integration.md splits 401
 *      from 503.
 */

/*
 * The texts themselves are in the `auth` catalogue (src/i18n/locales/<lang>/auth.json); these are
 * their keys, still one constant each, so there is still one place each can come from.
 */

/** The owner's line, verbatim. */
export const NO_PASSWORD_LINE = 'copy.noPasswordLine';

/**
 * ONE message for unknown, expired and already-used. Do not add a second.
 *
 * It does not invite a retry of the same code, because the code is dead in all three cases; it
 * points at the two doors that still work.
 */
export const HANDOFF_CODE_DEAD_TITLE = 'copy.handoffCodeDead.title';
export const HANDOFF_CODE_DEAD_BODY = 'copy.handoffCodeDead.body';

/** The 503. It says what is happening and what is NOT happening. */
export const IDENTITY_UNAVAILABLE_TITLE = 'copy.identityUnavailable.title';
export const IDENTITY_UNAVAILABLE_BODY = 'copy.identityUnavailable.body';
